import AsyncValidator from 'async-validator'
import store from '@/store'
import Vue from 'vue';
import router from '@/router'
import { SET_LOGIN_USER } from '@/store/mutation-types'

const utils = {
	/**
	 * 非空验证
	 */
	isNullOrEmpty(input) {
		return input === null || input === undefined || input === '' || input === '____/__/__';
	},
	/**
	 * 非空验证
	 */
	isNullOrWhiteSpace(input) {
		if (!utils.isNullOrEmpty(input)) {
			return utils.isNullOrEmpty(new String(input).trim());
		}
		return true;
	},
	validate: (model, rules, callback, options) => {
		const initOptions = {
			showMessage: true
		}
		options = Object.assign({}, initOptions, options || {})
		// 如果需要验证的fields为空，调用验证时立刻返回callback
		if ((!rules || rules.length === 0) && callback) {
			callback(true, null);
		}
		let errors = []
		const props = Object.keys(rules)
		for (let i in props) {
			const prop = props[i]
			const value = utils.getValueByProp(model, prop)
			utils.validateItem(rules, prop, value, (err) => {
				if (err && err.length > 0) {
					errors = errors.concat(err)
				}
			})
		}
		if (errors.length > 0) {
			callback(false, errors)
		} else {
			callback(true, null)
		}
	},
	validateField: (model, rules, props, callback, options) => {
		const initOptions = {
			showMessage: true
		}
		options = Object.assign({}, initOptions, options || {})
		props = [].concat(props)
		if (props.length === 0) {
			return
		}
		let errors = []
		for (let i in props) {
			const prop = props[i]
			const value = utils.getValueByProp(model, prop)
			utils.validateItem(rules, prop, value, (err) => {
				if (err && err.length > 0) {
					errors = errors.concat(err)
				}
			})
		}
		if (errors.length > 0) {
			callback(false, errors)
		} else {
			callback(true, null)
		}
	},
	validateItem(rules, prop, value, callback) {
		if (!rules || JSON.stringify(rules) === '{}') {
			if (callback instanceof Function) {
				callback();
			}
			return true;
		}
		const propRules = [].concat(rules[prop] || []);
		const descriptor = {
			[prop]: propRules
		};
		const validator = new AsyncValidator(descriptor);
		const model = {
			[prop]: value
		};
		validator.validate(model, {
			firstFields: true
		}, (errors) => {
			callback(errors);
		});
	},
	getValueByProp: (obj, prop) => {
		let tempObj = obj;
		prop = prop.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '');
		let keyArr = prop.split('.');
		let i = 0;
		for (let len = keyArr.length; i < len - 1; ++i) {
			if (!tempObj) break;
			let key = keyArr[i];
			if (key in tempObj) {
				tempObj = tempObj[key];
			} else {
				break;
			}
		}
		return tempObj ? (typeof tempObj[keyArr[i]] === 'string' ? tempObj[keyArr[i]].trim() : tempObj[keyArr[i]]) :
			null
	},
	/**
	 * 获得字符字节长度
	 */
	getStringByteLength(val) {
		if (utils.isNullOrEmpty(val)) {
			return 0;
		}
		var str = new String(val);
		var bytesCount = 0;
		for (var i = 0, n = str.length; i < n; i++) {
			var c = str.charCodeAt(i);
			if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
				bytesCount += 1;
			} else {
				bytesCount += 2;
			}
		}
		return bytesCount;
	},
	/**
	 * 响应处理
	 * res:   resolve的数据
	 * error: reject的数据
	 */
	responseHandle(res, error) {
		if (!res || (res.code != 200 && res.code != 100)) {
			return null;
		}
		return res;
	},
	/**
	 * 日期格式化
	 * @param {*} date 需要格式化的日期
	 * @param {*} format 日期格式
	 * @returns 格式化后的日期
	 */
	dateFormat(date, format) {
		var args = {
			"M+": date.getMonth() + 1,
			"d+": date.getDate(),
			"h+": date.getHours(),
			"m+": date.getMinutes(),
			"s+": date.getSeconds(),
			"q+": Math.floor((date.getMonth() + 3) / 3),  //quarter
			"S": date.getMilliseconds()
		};
		if (/(y+)/.test(format))
			format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (var i in args) {
			var n = args[i];
			if (new RegExp("(" + i + ")").test(format))
				format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? n : ("00" + n).substr(("" + n).length));
		}
		return format;
	},
	//千位符数字格式化
	toThousands(param) {
		// var result = [], counter = 0;
		// num = (num || 0).toString().split('');
		// for (var i = num.length - 1; i >= 0; i--) {
		// 	counter++;
		// 	result.unshift(num[i]);
		// 	if (!(counter % 3) && i != 0) { result.unshift(','); }
		// }
		// return result.join('');+
		const num = param + '';
		const numGroup = num.includes('.') ? num.split('.') : [num];
		const intFn = numStr =>
			numStr
				.split('')
				.reverse()
				.reduce((prev, next, index) => {
					return (index % 3 ? next : next + ',') + prev;
				});
		const intNum = intFn(numGroup[0]);
		const floatNum = numGroup[1] ? '.' + numGroup[1] : '';
		return intNum + floatNum;
	},
	FourNumber(num){

		var  number = String(num).replace(/^(.*\..{4}).*$/,"$1");
		number = Number(number); 
		return number;
	},
	/*计算百分比不为100%的情况*/
     getPercentValue (valueList, idx, precision) {
		// 判断是否为空
		if (!valueList[idx]) {
			return 0;
		}
		// 求和
		var sum = valueList.reduce(function (acc, val) {
			return acc + (isNaN(val) ? 0 : val);
		}, 0)
		if (sum === 0) {
			return 0;
		}
		// 10的2次幂是100，用于计算精度。
		var digits = Math.pow(10, precision);
		// 扩大比例100，
		var votesPerQuota = valueList.map(function (val) {
			return (isNaN(val) ? 0 : val) / sum * digits * 100;
		})
		// 总数，扩大比例意味的总数要扩大
		var targetSeats = digits * 100;
		// 再向下取值，组成数组
		var seats = votesPerQuota.map(function (votes) {
			return Math.floor(votes);
		})
		// 再新计算合计，用于判断与总数量是否相同，相同则占比会100%
		var currentSum = seats.reduce(function (acc, val) {
			return acc + val;
		}, 0)
		// 余数部分的数组：原先数组减去向下取值的数组，得到余数部分的数组
		var remainder = votesPerQuota.map(function (votes, idx) {
			return votes - seats[idx];
		})
		// 给最大最大的余额加1，凑个占比100%；
		while (currentSum < targetSeats) {
			//  找到下一个最大的余额，给其加1
			var max = Number.NEGATIVE_INFINITY;
			var maxId = null;
			for (var i = 0, len = remainder.length; i < len; ++i) {
				if (remainder[i] > max) {
					max = remainder[i];
					maxId = i;
				}
			}
			// 对最大项余额加1
			++seats[maxId];
			// 已经增加最大余数加1，则下次判断就可以不需要再判断这个余额数。
			remainder[maxId] = 0;
			// 总的也要加1，为了判断是否总数是否相同，跳出循环。
			++currentSum;
		}
		// 这时候的seats就会总数占比会100%
		return seats[idx] / digits
	},
	/**
	* 自定义函数名：PrefixZero
	* @param num： 被操作数
	* @param n： 固定的总位数
	*/
	PrefixZero(num, n) {
		return (Array(n).join(0) + num).slice(-n);
	},

	/**
	 * 下载文件
	 * @param {*} url 
	 * @param {*} fileName 
	 */
	downloadFile(url, fileName) {
		Vue.prototype.$loading.show();

		// 获取XMLHttpRequest
		let xmlResquest = new XMLHttpRequest();
		//  发起请求
		xmlResquest.open("GET", url, true);
		// 设置请求头类型
		xmlResquest.setRequestHeader("Content-type", "application/json");
		//  设置请求token
		xmlResquest.setRequestHeader("Authorization", "Bearer " + store.getters.token);
		// 设置请求语言
		xmlResquest.setRequestHeader("Accept-Language", store.getters.lang);
		xmlResquest.responseType = "blob";
		//  返回
		xmlResquest.onload = function (oEvent) {
			// console.log(url);
            //  console.log("xmlResquest")
			// console.log(xmlResquest);
			//跳转到登录页面
			if (xmlResquest.status == 401) {
				Vue.prototype.$loading.close();
				alert(Vue.prototype.i18n.t('login_expired'));
				store.commit(SET_LOGIN_USER, null);
				router.push({ name: "login" });
				return;
			} else if (xmlResquest.status != 200) {
				Vue.prototype.$loading.close();
				alert('error ' + xmlResquest.responseText);
				return;
			}

			let content = xmlResquest.response;
			// 组装a标签
			let elink = document.createElement("a");
			// 设置下载文件名
			elink.download = fileName + ".xlsx";
			elink.style.display = "none";
			let blob = new Blob([content]);
			elink.href = URL.createObjectURL(blob);
			document.body.appendChild(elink);
			elink.click();
			document.body.removeChild(elink);
			Vue.prototype.$loading.close();
		};
		xmlResquest.onerror = function () {
			Vue.prototype.$loading.close();
		}


		xmlResquest.send();
	}
};

//扩展Promise
function Extension() {
	if (Promise.prototype.always) return;
	Promise.prototype.always = function (callback) {
		return this.then(function (d) {
			return callback(d, undefined)
		}, function (e) {
			return callback(undefined, e)
		})
	}
	Promise.prototype.getResponseAsync = function () {
		return this.always(utils.responseHandle);
	}
}
Extension();



export default utils
